<template>
  <v-card-actions style="position: absolute; top:10px; right: 0px;">
    <v-card color="warning white--text" class="subtitle-2" flat>
      <b style="padding:5px">{{ label }}</b>
    </v-card>
  </v-card-actions>
</template>
<script>
export default {
  props: { label: String },
  data() {
    return {};
  },
};
</script>
